import { FilterChip } from "plos/src/components/Chip";
import { chipRowStyles } from "plos/src/components/FilterSheet/FilterChipRow/filterChipRow.css";
import { useTranslation } from "react-i18next";
import { ElementFilterPopover } from "./ElementFilterPopover";
import { ProgressFilterPopover } from "./ProgressFilterPopover";
import { PriceChangeElementFilter, PriceChangeProgressFilter } from "./utils";

interface PriceChangeFiltersProps {
  handleResetFilters: () => void;
  hasEntry: boolean;
  progressFilter: PriceChangeProgressFilter;
  onProgressFilterChange: (value: PriceChangeProgressFilter) => void;
  elementFilter: PriceChangeElementFilter;
  onElementFilterChange: (value: PriceChangeElementFilter) => void;
  isSortModified: boolean;
  isSearchModified?: boolean;
  showLockedOption: boolean;
}

const PriceChangeFilters = ({
  handleResetFilters,
  hasEntry,
  progressFilter,
  onProgressFilterChange,
  elementFilter,
  onElementFilterChange,
  isSortModified,
  isSearchModified = false,
  showLockedOption,
}: PriceChangeFiltersProps) => {
  const { t } = useTranslation("priceChanges");

  const hasModifiedFilters =
    progressFilter !== "riseAndDrop" ||
    elementFilter !== "all" ||
    isSortModified ||
    isSearchModified;

  return (
    <div className={chipRowStyles}>
      <ProgressFilterPopover
        value={progressFilter}
        onChange={onProgressFilterChange}
        showLockedOption={showLockedOption}
      />
      <ElementFilterPopover
        value={elementFilter}
        onChange={onElementFilterChange}
        hasEntry={hasEntry}
      />
      <FilterChip
        label={t("elementFilterChipRow.reset", "Reset") as string}
        onClick={handleResetFilters}
        isDisabled={!hasModifiedFilters}
        mode="reset"
      />
    </div>
  );
};

export default PriceChangeFilters;
